module.exports = __webpack_public_path__ + "img/innovacion_desarrollo.56f8a596.png";